import * as PIXI from "pixi.js";
import { Spine } from "@pixi/spine-pixi";
import { soundManager } from "src/shared/UI/SoundManager";

export class Character extends PIXI.Container {
    private character: Spine;
    private winLayer: PIXI.Graphics;

    constructor() {
        super();

        this.winLayer = new PIXI.Graphics().rect(-2000, -2000,
            4000, 4000).fill(0);
        this.winLayer.alpha = 0.7;

        this.character = Spine.from({
            skeleton: 'characterJson',
            atlas: 'characterAtlas',
        });
        this.character.scale.set(0.5);
        this.character.skeleton.setSkinByName('main');
        this.character.state.setAnimation(0, `idle_off`, true);
        this.character.state.addListener({
            complete: (entry) => {
                if (entry.animation) {
                    this.emit(entry.animation.name);
                }
            },
        })
        // this.character.blendMode = 'darken';

        this.addChild(this.character);
    }

    public setSkin(skin: string) {
        this.character.skeleton.setSkinByName(skin);
        this.character.skeleton.setSlotsToSetupPose();
        this.character.state.setAnimation(0, `idle_off`, true);
    }

    public async showDoves() {
        return new Promise<void>(async (resolve) => {
            await soundManager.playSound("multiplierTrigger");
            this.character.state.setAnimation(0, `dove_show`, false);
            this.character.state.addAnimation(0, `dove_hide`, false);
            this.character.state.addAnimation(0, `idle_off`, true);
            setTimeout(resolve, 1000);
        });
    }

    public async show(totalWin: number) {
        return new Promise<void>((resolve) => {
        })
    }

    public async close() {
    }
}
